export default __webpack_public_path__ + "static/media/customerIcon.823c75aa.svg";